export const toPercentage = (total: number, fraction?: number) => {
  let percentage = 0
  if (!fraction) percentage = 0
  else if (!total) percentage = 1
  else percentage = fraction / total
  return Math.round(percentage * 100)
}

export const limitDecimal = (value: number, afterDot?: number) =>
  +parseFloat((value || 0).toString()).toFixed(afterDot || 0)

export const commaSeparatedNumber = (number?: number) =>
  !number ? '0' : number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export function kFormatter(number?: number): string {
  if (!number) return '0'
  const value = Math.sign(number) * Math.abs(number)
  return Math.abs(number) > 999
    ? (value / 1000).toFixed(1).replace('.0', '') + 'K'
    : value.toLocaleString()
}

export function showKiloOrMillion(visits: number): string {
  return visits >= 1000000 ? `${visits / 1000000}M` : `${visits / 1000}K`
}

export const calcPercentage = (selectedItems: number, allItems: number): number => {
  if (allItems === 0) {
    return 0
  }
  return (selectedItems / allItems) * 100
}

export const formatNumber = (num: number) => {
  if (num < 9950) {
    return num.toLocaleString()
  } else if (num < 999950) {
    const thousands = Math.round(num / 100) / 10
    return thousands % 1 === 0 ? `${thousands.toFixed(0)}K` : `${thousands.toFixed(1)}K`
  } else {
    const millions = Math.round(num / 100000) / 10
    return millions % 1 === 0 ? `${millions.toFixed(0)}M` : `${millions.toFixed(1)}M`
  }
}

export const toFullPercentage = (total: number, fraction?: number) => {
  let percentage = 0
  if (!fraction) percentage = 0
  else if (!total) percentage = 1
  else percentage = fraction / total
  return percentage * 100
}

export const toPercentageTrend = (first = 0, second = 0) => {
  if (isNaN(first) || isNaN(second)) return 0

  let result = 0
  const change = second - first

  if (change && first) {
    result = (change / first) * 100
  }

  return Math.round(result)
}
